<template>
    <v-toolbar
            color="blue darken-4"
            dark
            app
            :clipped-left="$vuetify.breakpoint.lgAndUp"
            fixed
            ref="toolbar"
    >
        <v-toolbar-title class="ml-0 pl-3">
            <v-toolbar-side-icon
                    @click="$store.commit('DRAWER_TOGGLE')">
            </v-toolbar-side-icon>
            <span class="hidden-sm-and-down">Portal de Estudiantes</span>
            <span class="hidden-md-and-up">ITTG</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>

        <v-toolbar-items>
            <v-menu bottom left offset-y attach>
                <v-btn flat slot="activator">
                    <v-icon dark v-if="!user.avatar">account_circle</v-icon>
                    <v-avatar size="32px" tile v-if="user.avatar">
                        <img
                                src="https://vuetifyjs.com/static/doc-images/logo.svg"
                                alt="Vuetify"
                        >
                    </v-avatar>
                </v-btn>
                <v-list light>
                    <v-list-tile @click="logout">
                        <v-list-tile-avatar>
                            <v-icon light>exit_to_app</v-icon>
                        </v-list-tile-avatar>
                        <v-list-tile-content>Cerrar Sesión</v-list-tile-content>
                    </v-list-tile>
                </v-list>
            </v-menu>
        </v-toolbar-items>
    </v-toolbar>
</template>

<script>
  import { mapState } from 'vuex'
  import { AUTH_LOGOUT, PUSH_NOTIFICATION_UNSUBSCRIBE } from '@/store/mutation-types'

  export default {
    name: 'AppToolbar',
    data: () => ({
      user: {
        avatar: null,
        name: 'Usuario'
      }
    }),
    computed: {
      ...mapState({
        isPushEnabled: state => state.app.pushNotificationEnabled
      })
    },
    methods: {
      logout: function () {
        if (this.isPushEnabled) {
          this.unsubscribe()
        }

        this.$store.dispatch(AUTH_LOGOUT)
          .then(() => {
            this.$router.push('/login')
          })
      },

      /**
       * Unsubscribe from push notifications.
       */
      unsubscribe () {
        this.$store.dispatch(PUSH_NOTIFICATION_UNSUBSCRIBE)
      }
    }
  }
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/components/core/AppToolbar.vue